import request from '@/utils/seftRequest';

export function createAccount(data) {
  return request('/ding/custService/createAccountBsnl', {
    method: 'POST',
    body: data,
  });
}

// 查询账单寄送方式
export function qryBilldeliveryMethod() {
  return request('/ding/acctService/qryBillDeliveryMethodBsnl');
}

// 查询账期
export function qryBillingCycleType(data) {
  return request('/ding/custService/qryBillingCycleTypeList', {
    method: 'POST',
    body: data,
  });
}
